import { render, staticRenderFns } from "./including_points.vue?vue&type=template&id=3381bc4a&scoped=true&"
import script from "./including_points.vue?vue&type=script&lang=js&"
export * from "./including_points.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3381bc4a",
  null
  
)

export default component.exports